import { DATE_FORMAT } from 'features/appointment/utils/format';
import { ReportType } from 'features/report/pages/ReportPage/constants';
import PrintSummaryBill from 'features/report/pages/ReportPage/RevenueIncome/components/PrintSummaryBill';
import reportActions from 'features/report/services/actions';
import userSelectors from 'features/user/services/selectors';
import { isEmpty } from 'lodash';
import moment from 'moment';
import shopSelectors from 'services/shop/selectors';
import { useAppDispatch } from 'store/hooks';
import styled from 'styled-components';
import PermissionManager from 'widgets/PermissionVerify';
import { verifyAdminPW } from 'widgets/RequestAdminLocalPW/Callback';
import BusinessInfoPopoverContent from './BusinessInfoPopoverContent';
import ContactUsPopoverContent from './ContactUsPopoverContent';
import HomeCouponMarketingModal, { useHomeCouponMarketingModal } from './CouponMarketing';
import HomeDiscountInfoBox from './HomeDiscountInfoBox';
import LastTicketPopoverContent from './LastTicketPopoverContent';
import PopoverInfoBox from './PopoverInfoBox';
import HistoryCheckInModal, { useHistoryCheckInModalRef } from './HistoryCheckInModal';
import { IStaffItemData } from 'services/shop/types/staff';
import HomeSaleAdjustmentModal, { useHomeSaleAdjustmentModal } from './SaleAdjustmentModal';

const InfoBox = () => {
  const allSetting = shopSelectors.data.allSetting();
  return (
    <Container>
      <PopoverInfoBox content={<BusinessInfoPopoverContent />} buttonText='Business Info' />
      <PopoverInfoBox content={<ContactUsPopoverContent />} buttonText='Contact Us' />
      <PopoverInfoBox content={<LastTicketPopoverContent />} buttonText='Last Service Info' isLastTicket />
      <HomeDiscountInfoBox />
      {!!allSetting?.displaySummaryReportHome && <PrintSummaryRevenue />}
      <PrintCouponMarketing />
      <HistoryCheckIn />
      <SaleAdjustment />
    </Container>
  );
};

export default InfoBox;

const Container = styled.div`
  background: transparent;
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
`;

const PrintSummaryRevenue = () => {
  const dispatch = useAppDispatch();
  return <PrintSummaryBill renderButton={({ onClick }) => <PopoverInfoBox onClick={async () => {
    const cb = () => {
      dispatch(
        reportActions.setParams({
          [ReportType.REVENUE]: {
            startTime: moment().format(DATE_FORMAT),
            endTime: moment().format(DATE_FORMAT),
          },
        })
      );
      setTimeout(() => {
        onClick();
      }, 100);
    };
    const result = await PermissionManager.verify(PermissionManager.PERMISSIONS.REPORT_VIEW);
    if (result !== null) {
      if (!result || result?.skip) return cb();
      if (!result.verifyData) return;
      return cb();
    }
    verifyAdminPW(cb);
  }} buttonText='Print Summary' isLastTicket />} />;
};

const PrintCouponMarketing = () => {
  const modalRef = useHomeCouponMarketingModal();
  const couponMarketing = userSelectors.getCouponMarketing();
  const onOpen = () => verifyAdminPW((_pin?: string, data?: IStaffItemData) => {
    modalRef.current?.open(data);
  });
  if (isEmpty(couponMarketing) || !couponMarketing?.length) return null;
  return <>
    <PrintSummaryBill renderButton={() => <PopoverInfoBox onClick={onOpen} buttonText='Print Coupon' isLastTicket />} />
    <HomeCouponMarketingModal ref={modalRef} />
  </>;
};


const HistoryCheckIn = () => {

  const modalRef = useHistoryCheckInModalRef();
  const onOpen = () => {
    modalRef.current?.open();
  };
  return <>
    <PopoverInfoBox onClick={onOpen} buttonText='Check-in Records' isLastTicket />
    <HistoryCheckInModal ref={modalRef} />
  </>;

};

const SaleAdjustment = () => {
  const modalRef = useHomeSaleAdjustmentModal();
  const onOpen = () => verifyAdminPW((_pin?: string, data?: IStaffItemData) => {
    modalRef.current?.open(data?.id);
  });

  return <>
    <PopoverInfoBox onClick={onOpen} buttonText='Sale Adjustment' isLastTicket />
    <HomeSaleAdjustmentModal ref={modalRef} />
  </>;
};
